const SW_URL = "/service-worker.js";

/**
 * Registers public/service-worker.js (offline app shell + Web Push) and lets a clicked notification route
 * inside the running app instead of reloading it.
 */
export function registerServiceWorker(router) {
    if (!("serviceWorker" in navigator))
        return;

    navigator.serviceWorker.addEventListener("message", (event) => {
        const data = event.data || {};
        if (data.type === "push-navigate" && typeof data.url === "string" && data.url.startsWith("/"))
            router.push(data.url).catch(() => undefined);
    });

    window.addEventListener("load", () => {
        navigator.serviceWorker.register(SW_URL, { scope: "/", updateViaCache: "none" })
            .catch((error) => console.error("Service worker registration failed", error));
    });
}

/** The registration, registering it now if the page loaded before it was done. Null when unsupported or failed. */
export async function getServiceWorkerRegistration() {
    if (!("serviceWorker" in navigator))
        return null;
    try {
        const existing = await navigator.serviceWorker.getRegistration("/");
        if (existing)
            return existing;
        await navigator.serviceWorker.register(SW_URL, { scope: "/", updateViaCache: "none" });
        return await navigator.serviceWorker.ready;
    } catch (error) {
        return null;
    }
}
